module.exports = __webpack_public_path__ + "static/media/Tracking_en.a7ad566a.png";